module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



//////////////////
// WEBPACK FOOTER
// ./node_modules/atoa/atoa.js
// module id = 297
// module chunks = 9